module.exports = __webpack_public_path__ + "static/media/haechan-8.jpeg";